<template>
  <main class="tutors-section d-flex">
    <aside>
      <v-expansion-panels multiple :value="[0, 1, 2, 3, 4]">
        <v-expansion-panel v-for="filter in filters" :key="filter.id">
          <v-expansion-panel-header>
            {{ $t(filter.title) }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <template v-for="subFilter of filter.subFilters">
                <v-checkbox
                  v-if="subFilter.type === 'Checkbox'"
                  :key="subFilter.id"
                  v-model="filterObj[filter.name]"
                  :label="$t(subFilter.name)"
                  :value="subFilter.value"
                  color="green"
                  hide-details
                  @change="triggerFilter"
                ></v-checkbox>
                <v-autocomplete
                  v-else-if="subFilter.type === 'Select'"
                  :key="subFilter.id"
                  auto-select-first
                  :items="tutorsCountries"
                  v-model="filterObj[filter.name]"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  :menu-props="{ maxHeight: '400' }"
                  deletable-chips
                  :label="$t(subFilter.name)"
                  color="green"
                  clear-icon="mdi-close-circle"
                  clearable
                  item-color="green"
                  @change="triggerFilter"
                ></v-autocomplete>
              </template>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </aside>
    <section>
      <h2 class="section-title">{{ $t("ourTutors") }}</h2>
      <p class="section-desc">
        {{ configs.tutors_text && configs.tutors_text.config_value }}
      </p>
      <button class="filteration-btn" @click="filtrationDialog = true">
        <img
          src="../../assets/images/tutors-list/filter_list.svg"
          alt="filteration"
        />
        <span>{{ $t("filters") }}</span>
      </button>
      <TutorsList :tutors="tutors" />
      <div class="w-100 d-flex justify-content-center">
        <v-progress-circular
          v-if="isFetching && !isFinished"
          color="green"
          v-bind:size="150"
          indeterminate
          class="mt-3 mx-auto"
        >
          {{ $t("loadingTutors") }}
        </v-progress-circular>
      </div>
      <div
        class="w-100 d-flex justify-content-center fs-3 mt-5"
        v-if="!isFetching && !tutors.length"
      >
        There's no tutors Found.
      </div>
    </section>
    <Modal
      fullscreen
      @closeModal="filtrationDialog = false"
      :isOpened="filtrationDialog"
      hide-default-header
      hide-default-footer
    >
      <template #header>
        <header class="d-flex align-items-center w-100">
          <p class="m-auto text-white">{{ $t("startSearching") }}</p>
          <v-icon
            color="white"
            class="justify-self-end"
            @click="filtrationDialog = false"
          >
            mdi-close
          </v-icon>
        </header>
      </template>
      <template #body>
        <div class="filtration-body">
          <div v-for="(filter, index) in filters" :key="filter.id">
            <h3 class="filtration-title">{{ $t(filter.title) }}</h3>
            <template v-for="subFilter of filter.subFilters">
              <v-checkbox
                v-if="subFilter.type === 'Checkbox'"
                v-model="filterObj[filter.name]"
                :key="subFilter.id"
                :label="subFilter.name"
                :value="subFilter.value"
                color="green"
                hide-details
                @change="triggerFilter"
              ></v-checkbox>
              <v-autocomplete
                v-else-if="subFilter.type === 'Select'"
                auto-select-first
                :items="tutorsCountries"
                :key="subFilter.id"
                v-model="filterObj[filter.name]"
                item-text="name"
                item-value="id"
                multiple
                chips
                :menu-props="{ maxHeight: '400' }"
                deletable-chips
                :label="subFilter.name"
                color="green"
                clear-icon="mdi-close-circle"
                clearable
                item-color="green"
                @change="triggerFilter"
              ></v-autocomplete>
            </template>
            <hr v-if="index < filters.length - 1" />
          </div>
        </div>
      </template>
    </Modal>
  </main>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import TutorsList from "../../components/NewReservation/TutorsList.vue";
import Modal from "../../components/global/Modal.vue";

export default {
  name: "Tutors",
  mixins: [GlobalMixin],
  components: {
    TutorsList,
    Modal,
  },
  data() {
    return {
      configs: JSON.parse(localStorage.getItem("configs")),
      tutors: [],
      filterationData: [],
      filterObj: {
        course_types: [],
        language_ids: [],
        genders: [],
        country_ids: [],
        class_sizes: [],
      },
      filtrationDialog: false,
      filters: [
        {
          id: 1,
          title: "courseType",
          name: "course_types",
          subFilters: [],
        },
        {
          id: 2,
          title: "tutorLanguage",
          name: "language_ids",
          subFilters: [],
        },
        {
          id: 3,
          title: "Gender",
          name: "genders",
          subFilters: [],
        },
        {
          id: 4,
          title: "Location",
          name: "country_ids",
          subFilters: [
            {
              id: 1,
              type: "Select",
              name: "Location",
            },
          ],
        },
        // {
        //   id: 5,
        //   title: "classSize",
        //   name: "class_sizes",
        //   subFilters: [],
        // },
      ],
      offset: 0,
      limit: 12,
      isFetching: false,
      isFinished: false,
    };
  },
  /**
   * Initialize Component
   */
  mounted() {
    // Add event listener to scroll
    window.addEventListener("scroll", this.handleScroll);
    // Get filteration Data API
    this.getFilterationData();
    if (Object.keys(this.$route.query).length) {
      Object.entries(this.$route.query).forEach(([key, value]) => {
        if (!value) return;

        value.split("_").forEach((v) => {
          if (key === "country_ids") this.filterObj[key].push(+v);
          else this.filterObj[key].push(v);
        });
      });
    }
    const filtration = Object.values(this.filterObj).some((f) => f.length > 0);
    this.getTutors(filtration ? this.filterObj : {});
    window.addEventListener("localstorageChange", (event) => {
      this.configs = JSON.parse(event.detail.storage.configs);
    });
  },
  /**
   * Destroy component
   */
  destroyed() {
    window.removeEventListener("scroll");
  },
  methods: {
    /**
     * Get all tutors
     * @param filtration filterObj
     */
    getTutors(filtration) {
      if (this.isFetching) return;
      this.isFetching = true;
      const body = {
        ...filtration,
        offset: this.offset,
        limit: this.limit,
      };

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}tutor/listing/`,
          body,
          this.headers
        )
        .then((res) => {
          if (!res.data.data.tutors.length) {
            this.isFinished = true;
            this.isFetching = false;
            return;
          }
          res.data.data.tutors.forEach((t) => this.tutors.push(t));
          this.isFetching = false;
          if (res.data.data.tutors.length < this.limit) this.isFinished = true;
        });
    },
    /**
     * Filter when selecting any filter from side menu
     * @returns void
     */
    triggerFilter() {
      this.tutors = [];
      this.offset = 0;
      this.isFinished = false;
      const filtration = Object.values(this.filterObj).some(
        (f) => f.length > 0
      );
      this.getTutors(filtration ? this.filterObj : {});
    },
    /**
     * Handle scroll to get more tutors
     * @returns void
     */
    handleScroll() {
      if (this.isFinished || this.isFetching) return;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= totalHeight) {
        this.offset += this.limit;
        const filtration = Object.values(this.filterObj).some(
          (f) => f.length > 0
        );
        this.getTutors(filtration ? this.filterObj : {});
      }
    },
    /**
     * Get filteration data
     * @retunrs void
     */
    getFilterationData() {
      this.axios
        .get(`${process.env.VUE_APP_APIEndPoint}tutor/filters/`, this.headers)
        .then((res) => {
          this.filterationData = res.data.data.filters;
          res.data.data.filters.forEach((filter) => {
            if (filter.api_param_name === "country_ids") return;

            const filtration = this.filters.find(
              (f) => f.name === filter.api_param_name
            );
            filter.options.forEach((option, optionIndex) => {
              filtration?.subFilters?.push({
                id: optionIndex + 1,
                type: "Checkbox",
                name: option.title,
                value: option.value.toString(),
              });
            });
          });
        });
    },
  },
  computed: {
    /**
     * Return countries of filteration Data
     * @returns country[]
     */
    tutorsCountries() {
      const countries = this.filterationData
        .find((f) => f.api_param_name === "country_ids")
        ?.options?.map((o) => ({
          id: o.value,
          name: o.title,
          name_ascii: o.title,
        }));
      return countries;
    },
  },
  watch: {
    /**
     * Watch for language Change to get the new Configs
     */
    ["$i18n.locale"]() {
      this.headers.headers["accept-language"] = localStorage.lang;
      this.getconfigurations();
      this.getTutors();
    },
  },
};
</script>
<style lang="scss">
:root {
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
.tutors-section {
  font-size: 1em;
  font-family: $font-family;
  display: flex;
  margin: 0 auto;
  padding: 50px 40px;
  min-width: $min-lg-screen;
  max-width: $max-xl-screen;
  gap: 25px;

  aside {
    width: 100%;
    max-width: 324px;
  }

  section {
    .section-title {
      color: $title;
      font-weight: 600;
      font-size: 1.75em;
      line-height: 2.125em;
      letter-spacing: 0.02275rem;
      margin-bottom: 20px;
    }

    .section-desc {
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      color: $paragraph;
      margin-bottom: 36px;
    }

    .filteration-btn {
      display: none;
    }
  }
}

@media all and (min-width: $min-md-screen) and (max-width: $max-md-screen) {
  .tutors-section {
    font-size: 0.75rem;
    padding: 50px 24px;
    min-width: $min-md-screen;
    max-width: $max-md-screen;

    aside {
      max-width: 162px;
    }

    section {
      font-size: 1rem;
    }
  }
}

@media all and (max-width: $min-md-screen) {
  .tutors-section {
    padding: 18px 16px;
    max-width: $max-sm-screen;
    min-width: $min-sm-screen;
    font-size: 1rem;

    aside {
      display: none;
    }

    section {
      .section-title {
        font-size: 1.75rem;
        margin-bottom: 8px;
      }

      .section-desc {
        font-size: 0.75rem;
        margin-bottom: 16px;
      }

      .filteration-btn {
        display: flex;
        justify-content: center;
        padding: 8px;
        text-align: center;
        gap: 7px;
        color: $darker-green;
        background: $white;
        border: 1px solid $darker-green;
        border-radius: 8px;
        width: 100%;
        margin-bottom: 16px;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  header {
    background: #5fd068;
    padding: 20px;
    color: $white;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1;
  }

  .filtration-body {
    padding: 20px 40px;

    .filtration-title {
      font-size: 1rem;
      color: #9f9f9f;
      margin-bottom: 20px;
      line-height: 1;
    }
  }
}

::v-deep .v-expansion-panels {
  .v-expansion-panel {
    &:not(:first-child) {
      margin-top: 24px;
    }

    &::after {
      display: none;
    }

    &::before {
      box-shadow: none;
    }

    .v-expansion-panel-header {
      background: $light-green;
      font-family: $font-family;
      font-size: $sec-font-size;
      min-height: auto;
      padding: 12px 20px;
      font-weight: 500;
      line-height: 20px;
      border-radius: 5px;
      border: 1px solid #e6e8ec;

      &.v-expansion-panel-header--active {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .v-expansion-panel-header__icon {
        i {
          color: $black;
        }
      }
    }

    .v-expansion-panel-content {
      border: 1px solid #e6e8ec;

      .v-expansion-panel-content__wrap {
        padding: 17px 28px;
      }
    }
  }
}

::v-deep .v-input--checkbox {
  margin-top: 20px;
  padding: 0;

  &:first-child {
    margin-top: 0;
  }

  .v-input__control {
    .v-input__slot {
      .v-label {
        margin-inline-start: 8px;
        font-size: 0.875em;
        color: #061c3d;
      }
    }
  }
}
</style>
